import SMBaloonBaseView from 'components/shared/SMBaloonBaseView';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMRoomBaloonView extends SMBaloonBaseView {
  
  render() {
    const room = this.props.room;
    const iconStyle = {
      backgroundImage: "url('"+ SMFormatHelper.roomImageURL(room, {width: 1200, height: 670}) +"')"
    };
    return (
      <div ref="baloon" className="baloon baloon-top space-detail-baloon"
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}>
        <div className="baloon-inner">
          <p className="space-detail-baloon__img" style={iconStyle}>{SMFormatHelper.roomName(room)}（{room.space.name}）</p>
          <p className="space-detail-baloon__name">{SMFormatHelper.roomName(room)}（{room.space.name}）</p>
          <div className="ta-c mt10">
            <a href="#" className="button-blue space-detail-baloon__button mr5">{I18n.t("dashboard.label_000087")}</a>
            <a href={Routes.edit_owner_dashboard_space_room_path(room.owner.username, room.space.username, room.uid)} className="button-blue space-detail-baloon__button">{I18n.t("dashboard.label_000094")}</a>
          </div>
        </div>
      </div>
    );
  }
}
export default SMRoomBaloonView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMRoomBaloonView.jsx